import React from "react";
import { Modal2 as Modal } from "@qgiv/core-donor";
import ConnectedRecurringSummaryCancelModalContent from "./ConnectedRecurringSummaryCancelModalContent";

/**
 * @param {object} props
 * @param {boolean} props.loading
 * @param {Function} props.onClose
 * @param {Function} props.setLoading
 * @returns {React.JSX.Element}
 */
const RecurringSummaryCancelModal = ({ loading, onClose, setLoading }) => (
    <Modal onClose={loading ? () => {} : onClose} closeOnClickOutside>
        <ConnectedRecurringSummaryCancelModalContent
            loading={loading}
            onClose={onClose}
            setLoading={setLoading}
        />
    </Modal>
);

export default RecurringSummaryCancelModal;
